import defaultConfig from './whitelabel/config';

const env = await fetch(
  `/env.json?release=${process.env.VUE_APP_VERSION}`
).then(async res => {
  const envVariables = await res.json();
  const tenant = res.headers.get('x-tenant') || res.headers.get('theme');
  let tenantConfig = {};

  if (tenant) {
    try {
      tenantConfig = await (
        await fetch(`/assets/tenants/${tenant}/config.json`)
      ).json();
    } catch (e) {
      console.log('Tenant config could not be loaded', e);
    }
  }

  return {
    ...envVariables,
    ...defaultConfig,
    ...tenantConfig,
    COUNTRY_CODE: res.headers.get('x-country'),
  };
});

export default env;
